import { render, staticRenderFns } from "./LanhuDetailContent.vue?vue&type=template&id=7c484879&scoped=true"
import script from "./LanhuDetailContent.vue?vue&type=script&lang=js"
export * from "./LanhuDetailContent.vue?vue&type=script&lang=js"
import style0 from "./LanhuDetailContent.vue?vue&type=style&index=0&id=7c484879&prod&scoped=true&lang=css"
import style1 from "../views/lanhu_wenzhangxiangqing/assets/index.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c484879",
  null
  
)

export default component.exports